module.exports = {
      id: "arrow_outward-usage",
      viewBox: "0 0 10 9",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#arrow_outward",
      toString: function () {
        return this.url;
      }
    }